// src/components/Form.js
import React, { useState } from "react";

export default function Form() {
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    correo: "",
    mensaje: ""
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");

    try {
      const response = await fetch("contact1/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData)
      });
      const result = await response.json();
      setStatus(result.message);
      if (result.status === "success") {
        setFormData({ nombre: "", telefono: "", correo: "", mensaje: "" });
      }
    } catch (error) {
      setStatus("Error al enviar el mensaje. Intenta más tarde.");
    }
  };

  return (
    <div className="cnt-inf-wrp text-center gry-bg3">
      <h4>Consulta</h4>
      <form onSubmit={handleSubmit}>
        <div className="row mrg20">
          <div className="col-md-6">
            <label>Nombre</label>
            <input
              name="nombre"
              type="text"
              placeholder="Sr o Sra"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label>Telefono</label>
            <input
              name="telefono"
              type="text"
              placeholder="+51 0351"
              value={formData.telefono}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Email</label>
            <input
              name="correo"
              type="email"
              placeholder=""
              value={formData.correo}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-12">
            <label>Mensaje</label>
            <textarea
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-12 boton-enviar">
            <button type="submit" className="rd2 btn1 ylw-bg">
              Enviar
            </button>
          </div>
        </div>
      </form>
      {status && <div className="alert alert-success mt-3">{status}</div>}
    </div>
  );
}